export const helpers = {
    analyticSellerUserIds: [7555, 53861,3, 3606, 7257],
    analyticNonAllowedUserIds: [3606],
}